import type { MaterialType } from "../types";
import {
  EGGER_DECORS,
  eggerDecor,
  type EggerDecor,
  type EggerDecorGroup
} from "./eggerDecors";

/**
 * Декор Egger заменил пять самодельных материалов: в производство уходит
 * артикул плиты, а не выдуманное название. Старое поле material осталось
 * в данных — оно вычисляется из декора и нужно подписям в PDF.
 */

/** Чем подменяется материал в проектах, сохранённых до появления каталога. */
export const LEGACY_MATERIAL_DECOR: Record<MaterialType, string> = {
  warmOak: "H3170 ST12",      // Дуб Кендал натуральный
  linen: "AF/F416 ST10",      // Текстиль бежевый
  matteWhite: "W1000 ST9",    // Белый Премиум
  walnut: "H1714 ST19",       // Орех Линкольн
  graphite: "U961 ST7"        // Чёрный графит
};

export const DEFAULT_DECOR_CODE = LEGACY_MATERIAL_DECOR.matteWhite;

/**
 * Старое поле material (для подписи материала в PDF и старых проектов).
 * Цену плиты оно больше не задаёт: смета берёт её из прайса по группе декора.
 */
const GROUP_PRICE_MATERIAL: Record<EggerDecorGroup, MaterialType> = {
  wood: "warmOak",
  stone: "linen",
  metal: "graphite",
  fabric: "linen",
  plain: "matteWhite"
};

export const decorPriceMaterial = (code: unknown): MaterialType => {
  const decor = eggerDecor(code);
  return decor ? GROUP_PRICE_MATERIAL[decor.group] : "matteWhite";
};

/**
 * Декор изделия: сохранённый артикул, иначе перевод старого материала,
 * иначе белый. Ответ никогда не пустой — сцене и спецификации всегда
 * есть что показать.
 */
export const resolveDecor = (
  code: unknown,
  material?: MaterialType
): EggerDecor => {
  const chosen = eggerDecor(code);
  if (chosen) return chosen;
  const legacy = material ? eggerDecor(LEGACY_MATERIAL_DECOR[material]) : undefined;
  return legacy ?? eggerDecor(DEFAULT_DECOR_CODE)!;
};

export const decorTextureUrl = (decor: EggerDecor) =>
  decor.texture ? `/textures/egger/${decor.texture}` : undefined;

/** Артикул и название одной строкой — для спецификации и подписей. */
export const decorLabel = (decor: EggerDecor) => `${decor.name} · ${decor.code}`;

/** Поиск по артикулу и названию для экрана выбора. */
export const searchDecors = (query: string, group?: EggerDecorGroup) => {
  const needle = query.trim().toLowerCase();
  return EGGER_DECORS.filter(decor => {
    if (group && decor.group !== group) return false;
    if (!needle) return true;
    return (
      decor.name.toLowerCase().includes(needle) ||
      decor.code.toLowerCase().includes(needle.toUpperCase().toLowerCase())
    );
  });
};
